var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon1-5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.388,
    height: 84.013,
    viewBox: "0 0 75.388 84.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_72",
    "data-name": "\\u9577\\u65B9\\u5F62 72",
    width: 75.388,
    height: 84.013,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_67",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 67",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_94",
    "data-name": "\\u30D1\\u30B9 94",
    d: "M32.533,6.583c-1.206,0-2.135.046-3.059-.01a3.337,3.337,0,0,1-3.157-3.349A3.269,3.269,0,0,1,29.469.045q6.4-.086,12.8,0a3.091,3.091,0,0,1,3.064,3.2,3.165,3.165,0,0,1-3.111,3.328c-.969.056-1.944.01-3.1.01,0,1.89-.037,3.626.037,5.358a1.167,1.167,0,0,0,.8.789A35.706,35.706,0,0,1,58.7,20.682l4.116-4.347c-.5-.523-1.186-1.2-1.824-1.909A3.278,3.278,0,1,1,65.573,9.74q4.481,4.337,8.817,8.824a3.267,3.267,0,1,1-4.618,4.621,19.994,19.994,0,0,1-1.789-2.23L63.6,25.635a37.123,37.123,0,0,1,7.445,15.984C74.972,60.525,61.6,80.213,42.56,83.447,22.741,86.812,4.989,74.88.76,55.349c-4.149-19.16,9.184-38.914,28.5-42.222,3.276-.561,3.276-.561,3.276-3.94v-2.6m32.5,41.707A29.212,29.212,0,1,0,35.86,77.519,29.182,29.182,0,0,0,65.036,48.29",
    transform: "translate(0 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_95",
    "data-name": "\\u30D1\\u30B9 95",
    d: "M105.62,97.484c3.491,0,6.716-.006,9.942,0,2.444.006,3.824,1.2,3.822,3.285s-1.385,3.271-3.832,3.276q-6.4.012-12.8,0c-2.278-.009-3.661-1.232-3.682-3.485-.06-6.292-.048-12.584-.005-18.876a3.37,3.37,0,0,1,2.834-3.513,3.227,3.227,0,0,1,3.441,1.957,6.31,6.31,0,0,1,.272,2.087c.023,4.432.012,8.864.012,13.3v1.974",
    transform: "translate(-66.506 -52.474)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon15);
export default __webpack_public_path__ + "static/media/point3icon1-5.8608ce64b7f2e1a9acd7050c10e12163.svg";
export { ForwardRef as ReactComponent };